import React, { useEffect, useRef, useState } from "react";
import styles from "../signUp/signup.module.scss";
import rocket from "../../assests/signUpRocket.png";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  let navigate = useNavigate();

  function navigateLogin(params) {
    navigate("/login");
  }

  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
        console.log(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (MyRef.current) {
      observer.observe(MyRef.current);
    }

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <div className={visible ? styles.signUpImgEvent : styles.signUpImg} ref={MyRef}>
            <img src={rocket} alt="" />
          </div>
          <h1>Let's Get Started</h1>
        </div>
        <div className={styles.right}>
          <div className={styles.form}>
            <h2>Sign up with us</h2>
            <p>
              Already have an account?{" "}
              <a onClick={navigateLogin} style={{ color: "blue" }}>
                Login
              </a>
            </p>
            <div className={styles.formContent}>
              <div className={styles.input}>
                <label htmlFor="">Full Name</label>
                <input type="text" placeholder="Enter Your Full Name" />
              </div>
              <div className={styles.input}>
                <label htmlFor="">Mobile Number</label>
                <input type="text" placeholder="Enter your mobile number" />
              </div>
              {/* <p>Verification</p> */}
              <div className={styles.input}>
                <label htmlFor="">Email ID</label>
                <input type="text" placeholder="Enter Your E-mail ID" />
              </div>
              <div className={styles.verifyBtn}>Verify Your Email</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
